import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FileText, Search } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminTaxForms = ({ token }) => {
  const navigate = useNavigate();
  const [forms, setForms] = useState(null);
  const [q, setQ] = useState('');

  useEffect(() => {
    axios.get(`${API}/pas-tax/admin/8824`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setForms(r.data.forms)).catch(() => setForms([]));
  }, [token]);

  const term = q.toLowerCase();
  const shown = (forms || []).filter(f => !term || `${f.name} ${f.email} ${f.check_number || ''} ${f.type}`.toLowerCase().includes(term));

  return (
    <div className="bg-slate-800 border border-slate-700 rounded-xl" data-testid="admin-tax-forms">
      <div className="p-4 border-b border-slate-700 flex items-center justify-between gap-3">
        <h3 className="text-white font-semibold">Form 8824 - All Customers ({shown.length})</h3>
        <div className="relative">
          <Search className="w-4 h-4 text-slate-500 absolute left-3 top-2.5" />
          <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search customer or check #" data-testid="admin-tax-search"
            className="bg-slate-900 border border-slate-600 rounded-lg pl-9 pr-3 py-2 text-white text-sm w-64" />
        </div>
      </div>
      <div className="divide-y divide-slate-700 max-h-[600px] overflow-y-auto">
        {forms === null && <p className="p-6 text-slate-400">Loading...</p>}
        {forms && shown.length === 0 && <p className="p-6 text-slate-500">No forms found</p>}
        {shown.map(f => (
          <button key={`${f.client_id}-${f.transaction_id}`} onClick={() => navigate(`/pas/admin/tax-forms/${f.client_id}/${f.transaction_id}`)}
            data-testid={`admin-tax-row-${f.client_id}-${f.transaction_id}`}
            className="w-full flex items-center justify-between px-5 py-3 hover:bg-slate-700/50 text-left">
            <div className="flex items-center gap-3">
              <FileText className="w-5 h-5 text-purple-400" />
              <div>
                <p className="text-white text-sm">{f.name} <span className="text-slate-500">{f.email}</span></p>
                <p className="text-xs text-slate-400 capitalize">{f.type.replace(/_/g, ' ')} {f.check_number && `#${f.check_number}`} &middot; {new Date(f.created_at).toLocaleDateString()} &middot; property {f.direction}{f.customer_edited ? ' · edited by customer' : ''}</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-white text-sm">{f.beth_amount.toLocaleString()} BETH</p>
              <p className="text-xs text-slate-400">${f.usd_value.toLocaleString(undefined, { minimumFractionDigits: 2 })}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
